module.exports = __webpack_public_path__ + "static/img/amblyopia_blance.65400b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amblyopia_blance.png
// module id = tMLy
// module chunks = 3